// src/cert/hitrust.js
import React from 'react';
import ApplyForm from '../components/ApplyForm';
import './CertPage.css';

const HITRUST = () => {
    return (
        <div className="cert-page">
            <div className="cert-header">
                <h1>HITRUST प्रमाणन</h1>
                <p>सुरक्षा आणि गोपनीयता फ्रेमवर्क (Security and Privacy Framework)</p>
            </div>

            <div className="cert-content">
                <section>
                    <h2>HITRUST म्हणजे काय?</h2>
                    <p>
                        HITRUST stands for the Health Information Trust Alliance. It was founded in 2007 and uses the HITRUST approach to help organizations from all sectors but especially healthcare effectively manage data, information risk, and compliance.

                        HITRUST certification by the HITRUST Alliance enables vendors and covered entities to demonstrate compliance to HIPAA requirements based on a standardized framework.

                        HITRUST was organized with the intent to provide an option for the healthcare sector to address information risk management across a matrix of third-party assurance assessments, with the hope of consolidating, reducing, and in some cases, eliminating the need for multiple reports. HITRUST refers to this design element as assess once, report many.

                        What is HITRUST CSF Certification

                        Organizations that create, access, store, or exchange sensitive information can use the HITRUST Common Security Framework (CSF) assessment as a roadmap to data security and compliance. The CSF is a certifiable by security assessors standard and was designed as a risk-based approach to organizational security as opposed to a compliance based approach. The HITRUST CSF assurance program combines aspects from common security frameworks like ISO, NIST, PCI, and HIPAA.

                        Between the CSFs 19 reporting domains are 149 control specifications which can each be assessed to one of three implementation levels.
                    </p>
                </section>

                <section>
                    <h2>प्रमुख फायदे</h2>
                    <ul>
                        <li>एकाच फ्रेमवर्कने HIPAA, SOC 2, NIST, ISO 27001 अनुपालन</li>
                        <li>ग्राहक, भागीदार आणि नियामकांना उच्च विश्वास</li>
                        <li>जोखीम कमी आणि अनुपालन खर्च वाचतो</li>
                        <li>99.41% ब्रेक-फ्री दर (सुरक्षित पर्यावरण)</li>
                        <li>आरोग्य क्षेत्रात (PHI संरक्षण) आणि इतर उद्योगांसाठी योग्य</li>
                    </ul>
                </section>

                <section className="apply-section">
                    <h2>HITRUST साठी अर्ज करा</h2>
                    <ApplyForm certification="HITRUST" />
                </section>
            </div>
        </div>
    );
};

export default HITRUST;